<template>
  <div>
    <p class="body-regular-small neutral-20-dark--text mb-0">
      {{ $t('message.navDrawer.userWarnings.reactivateAccount.title') }}
    </p>
    <p class="text-caption neutral-40-light--text">
      {{ $t('message.navDrawer.userWarnings.reactivateAccount.subtitle') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ReactivateAccountMessage',
}
</script>

<style scoped>
.text-caption {
  font-size: 12px;
  line-height: 150%;
  margin-bottom: 0;
}
</style>